import React from "react";
import Hero from "../../components/pages/Law/Hero/Hero";
import "./Law.css";
import Steps from "../../components/pages/Law/Steps/Steps";

const Law = () => {
  return (
    <div className="law-page">
      <div className="law-page__grid-section">
        <Hero />
      </div>
      <Steps />
    </div>
  );
};

export default Law;
